import React, {FC} from 'react';

/** 使用条款中文正文（i18n：壳组件按语言选择 zh/en 内容组件，类名复用 TermsOfUse__* BEM） */
const ZhContent: FC = () => {
  return (
    <>
      <p className="v3-doc-meta">生效时间: 2026年8月28日</p>
      <p className="v3-doc-meta">上次更新时间: 2026年8月28日</p>
      <p>欢迎您使用象寄提供的产品及服务！</p>
      <p>
        本《象寄用户服务条款》（以下简称“本条款”）是您与 <strong>[象寄实际运营主体全称]</strong>
        （以下简称“象寄”“我们”）之间关于注册、登录及使用象寄相关产品和服务所订立的协议。
      </p>
      <p>
        象寄主要为跨境电商及其他商业用户提供AI视觉内容处理与创作服务，包括但不限于图片翻译、图片编辑、图片生成、商品场景图生成、商品模特图生成、商品详情套图生成、商品主图及副图生成、营销素材生成以及其他相关服务。
      </p>
      <p>
        <strong>
          请您在使用象寄服务前仔细阅读并充分理解本条款，特别是以粗体标示的涉及您重大权益的条款，包括但不限于免责声明、责任限制、用户内容及知识产权、AI生成内容、服务变更、账号管理、法律责任及争议解决等条款。
        </strong>
      </p>
      <p>如果您不同意本条款的任意或全部内容，请不要注册、登录或使用象寄服务。</p>
      <p>
        您通过网页点击“同意”“注册”“登录”“开始使用”“确认”等按钮，或者实际注册、登录、购买或使用象寄服务，即视为您已经阅读、理解并同意接受本条款的全部约定。
      </p>
      <p>
        如果您代表某个企业、机构或其他组织使用象寄服务，您确认并保证您已获得充分授权，有权代表该企业、机构或组织接受本条款，并由该主体承担相应责任。
      </p>
      <section>
        <h2>一、条款的范围与确认</h2>
        <h3>象寄及产品服务</h3>
        <p>
          本条款中的“象寄”“本平台”是指
          苏州象寄科技服务有限公司及其运营的网站、网页应用、客户端、浏览器插件以及其他相关产品和服务。
        </p>
        <p>象寄官方网站为：</p>
        <p>
          <a href="https://www.xiangjifanyi.com/" rel="noreferrer" target="_blank">
            <strong>https://www.xiangjifanyi.com/</strong>
          </a>
        </p>
        <p>具体服务内容以象寄实际提供的产品功能、服务页面及相关规则为准。</p>
        <h3>产品服务</h3>
        <p>“产品服务”是指象寄向用户提供的各类互联网及AI相关服务，包括但不限于：</p>
        <ul>
          <li>图片翻译；</li>
          <li>图片编辑及修图；</li>
          <li>图片背景处理；</li>
          <li>商品图片生成；</li>
          <li>商品场景图生成；</li>
          <li>商品模特图生成；</li>
          <li>商品主图、副图生成；</li>
          <li>商品详情套图生成；</li>
          <li>商品详情页、A+等内容生成；</li>
          <li>视频及视觉内容处理；</li>
          <li>文件及PSD相关处理；</li>
          <li>API及其他技术服务；</li>
          <li>象寄未来推出的其他相关服务。</li>
        </ul>
        <p>
          <strong>具体服务内容、功能、服务标准、收费方式及使用规则，以象寄实际提供的服务及相关页面说明为准。</strong>
        </p>
        <h3>其他协议</h3>
        <p>
          本条款与象寄隐私政策、AI创作相关协议、订阅服务购买协议、API服务协议及其他专项服务规则共同构成象寄服务条款体系。
        </p>
        <p>如您使用象寄的特定服务，还应遵守该服务对应的专项协议或规则。</p>
        <p>如专项协议与本条款存在不一致，以专项协议就相关事项作出的约定为准。</p>
        <h3>条款修改</h3>
        <p>
          <strong>
            鉴于互联网及人工智能技术的快速发展，象寄有权根据法律法规变化、业务发展、技术升级及服务调整，对本条款进行修改或补充。
          </strong>
        </p>
        <p>如本条款发生重大变更，象寄将通过网站公告、产品页面、弹窗、站内通知或其他合理方式向您进行提示。</p>
        <p>修改后的条款自公布或规定的生效日期起生效。</p>
        <p>
          <strong>
            如果您不同意修改后的条款，您应停止使用相关服务；如您继续访问或使用象寄服务，则视为您已经接受修改后的条款。
          </strong>
        </p>
      </section>
      <section>
        <h2>二、账号注册与安全</h2>
        <h3>账号注册</h3>
        <p>您在使用部分象寄服务前，需要注册或登录象寄账号。</p>
        <p>您应当按照注册页面的要求提供真实、准确、完整的信息，并及时更新相关信息。</p>
        <p>
          <strong>您不得使用虚假、冒用、盗用他人身份信息或其他不正当方式注册、使用象寄账号。</strong>
        </p>
        <h3>账号安全</h3>
        <p>您有责任妥善保管您的账号、密码及其他身份认证信息。</p>
        <p>您应对通过您的账号实施的所有操作承担相应责任。</p>
        <p>因您自身原因导致账号、密码、验证码等信息泄露、被盗用或被他人非法使用而产生的损失，由您自行承担。</p>
        <h3>账号共享</h3>
        <p>
          除象寄明确允许的企业版、多用户协作等功能外，
          <strong>您不得以出租、出借、出售、转让、共享账号等方式向他人提供账号使用权。</strong>
        </p>
        <p>
          如象寄发现账号存在异常共享、批量使用、恶意注册、异常调用或其他可能影响平台安全的行为，有权采取限制登录、限制功能、暂停服务或终止账号等措施。
        </p>
        <h3>第三方账号</h3>
        <p>如您通过Google、微信或其他第三方账号登录象寄，您应遵守相关第三方平台的服务规则。</p>
        <p>因第三方账号本身原因导致您无法登录或使用象寄服务的，象寄不承担由此产生的责任。</p>
        <h3>账号注销</h3>
        <p>您可以根据象寄提供的方式申请注销账号。</p>
        <p>
          <strong>
            账号注销后，与该账号相关的服务权益、未使用额度、历史数据及其他内容可能按照象寄相关规则被删除或失效，法律法规另有规定或双方另有约定的除外。
          </strong>
        </p>
      </section>
      <section>
        <h2>三、用户使用规则</h2>
        <p>您承诺在使用象寄服务过程中遵守中华人民共和国及适用的其他国家和地区的法律法规、社会公德及公序良俗。</p>
        <p>您不得利用象寄服务实施以下行为：</p>
        <h3>违法违规内容</h3>
        <p>不得制作、生成、上传、发布、传播或存储：</p>
        <ul>
          <li>违反法律法规的内容；</li>
          <li>危害国家安全、公共安全或社会稳定的内容；</li>
          <li>淫秽、色情、暴力、恐怖主义、极端主义内容；</li>
          <li>诈骗、赌博、传销等违法内容；</li>
          <li>侮辱、诽谤、骚扰他人的内容；</li>
          <li>其他法律法规禁止的内容。</li>
        </ul>
        <h3>侵犯第三方权益</h3>
        <p>不得利用象寄服务侵犯任何第三方合法权益，包括但不限于：</p>
        <ul>
          <li>著作权；</li>
          <li>商标权；</li>
          <li>专利权；</li>
          <li>肖像权；</li>
          <li>隐私权；</li>
          <li>名誉权；</li>
          <li>商业秘密；</li>
          <li>其他合法权益。</li>
        </ul>
        <h3>虚假及误导性内容</h3>
        <p>不得利用象寄服务制作、传播虚假、欺诈、误导消费者或其他可能损害他人合法权益的内容。</p>
        <h3>恶意使用</h3>
        <p>不得利用程序、脚本、机器人、爬虫或其他自动化手段：</p>
        <ul>
          <li>批量注册账号；</li>
          <li>恶意调用服务；</li>
          <li>绕过使用限制；</li>
          <li>破解或规避计费机制；</li>
          <li>刷取服务额度；</li>
          <li>干扰平台正常运行；</li>
          <li>对平台进行压力测试或攻击。</li>
        </ul>
        <h3>系统及技术保护</h3>
        <p>
          <strong>
            未经象寄书面许可，您不得对象寄网站、软件、接口、服务器、模型或其他技术系统进行反向工程、反编译、反汇编、破解、复制、修改或其他形式的技术分析。
          </strong>
        </p>
        <p>您不得：</p>
        <ul>
          <li>破解平台程序；</li>
          <li>修改或篡改平台功能；</li>
          <li>绕过技术保护措施；</li>
          <li>未经授权访问服务器；</li>
          <li>获取非公开数据；</li>
          <li>探测平台安全漏洞并实施攻击；</li>
          <li>以其他方式干扰平台正常运行。</li>
        </ul>
        <h3>其他禁止行为</h3>
        <p>不得实施其他违反法律法规、本条款或象寄其他服务规则的行为。</p>
      </section>
      <section>
        <h2>四、用户上传内容</h2>
        <h3>用户内容</h3>
        <p>
          “用户内容”是指您在使用象寄服务过程中上传、提交、输入、生成、编辑、保存或以其他方式提供给象寄的文字、图片、照片、视频、音频、商品信息、设计文件、PSD文件以及其他内容。
        </p>
        <h3>权利保证</h3>
        <p>
          <strong>您应确保您向象寄提供的用户内容具有合法来源，并已获得使用该内容所必需的全部权利、授权及许可。</strong>
        </p>
        <p>
          尤其是涉及第三方人物肖像、商品图片、品牌商标、字体、音乐、影视作品、设计作品等内容时，您应确保已经取得必要授权。
        </p>
        <h3>用户内容权利归属</h3>
        <p>除法律法规另有规定或双方另有约定外，您对依法属于您的用户内容所享有的权利不会因您使用象寄服务而发生改变。</p>
        <p>象寄不会通过本条款无偿取得您用户内容的所有权。</p>
        <h3>服务所必需的授权</h3>
        <p>
          为了向您提供服务，您同意授予象寄一项
          <strong>非独家、全球范围、免许可费的使用许可</strong>
          ，允许象寄在提供、维护、优化和改进相关服务所必需的范围内，对您的用户内容进行存储、复制、传输、处理、分析及技术加工。
        </p>
        <p>该授权在实现前述服务目的所必要的期限内有效。</p>
        <h3>内容删除</h3>
        <p>
          如象寄发现或收到举报，认为您上传或生成的内容可能违反法律法规、本条款或侵犯第三方合法权益，象寄有权根据实际情况对相关内容采取删除、屏蔽、限制访问或其他合理措施。
        </p>
      </section>
      <section>
        <h2>五、AI生成内容特别条款</h2>
        <p>象寄部分服务基于人工智能模型、生成式AI技术、机器学习算法及第三方AI基础设施提供。</p>
        <h3>生成结果具有不确定性</h3>
        <p>
          <strong>
            您理解并同意，AI生成结果具有一定的不确定性，象寄无法保证生成结果始终准确、完整、真实、合法、符合您的预期或不存在与第三方作品相似的情况。
          </strong>
        </p>
        <p>生成结果可能出现：</p>
        <ul>
          <li>图片内容与输入不一致；</li>
          <li>商品细节错误；</li>
          <li>商品结构或比例错误；</li>
          <li>文字识别或翻译错误；</li>
          <li>人物或场景生成异常；</li>
          <li>事实错误；</li>
          <li>其他AI生成技术本身可能产生的问题。</li>
        </ul>
        <h3>人工审核责任</h3>
        <p>
          <strong>您应当对AI生成、翻译、编辑或处理后的最终内容进行人工审核。</strong>
        </p>
        <p>
          尤其是商品价格、尺寸、规格、材质、功能、性能、认证、功效等可能影响消费者决策的信息，您应在发布、销售或广告投放前自行核验。
        </p>
        <p>因您未经审核直接使用AI生成内容而产生的损失或纠纷，由您依法承担相应责任。</p>
        <h3>生成结果不保证唯一</h3>
        <p>相同或类似的输入可能生成相同或不同的结果。</p>
        <p>象寄不保证AI生成结果具有唯一性，也不保证其他用户不会生成与您相似或相同的内容。</p>
        <h3>第三方模型</h3>
        <p>象寄部分功能可能使用第三方AI模型、翻译引擎、云计算服务或其他第三方技术服务。</p>
        <p>
          <strong>
            因第三方模型或服务发生故障、升级、限制、调整、暂停或终止而导致相关服务受到影响的，象寄将在合理范围内采取替代或恢复措施，但法律另有规定的除外。
          </strong>
        </p>
        <h3>AI生成内容的商业使用</h3>
        <p>用户应根据适用法律法规、第三方模型服务条款及象寄具体产品规则使用AI生成内容。</p>
        <p>
          <strong>
            对于用于商业发布、广告投放、商品销售等场景的内容，用户应自行确认其具有合法使用基础，并承担相应商业使用责任。
          </strong>
        </p>
      </section>
      <section>
        <h2>六、知识产权</h2>
        <h3>象寄知识产权</h3>
        <p>
          <strong>
            象寄网站、软件、产品、页面设计、商标、Logo、文字、图片、程序、算法、模型、数据库、技术文档以及其他由象寄提供的内容，其知识产权归象寄或相关权利人所有。
          </strong>
        </p>
        <p>未经象寄或相关权利人书面许可，您不得：</p>
        <ul>
          <li>复制；</li>
          <li>修改；</li>
          <li>传播；</li>
          <li>出售；</li>
          <li>出租；</li>
          <li>反向工程；</li>
          <li>商业化利用；</li>
          <li>以其他方式侵犯相关知识产权。</li>
        </ul>
        <h3>用户内容</h3>
        <p>用户对依法属于自己的用户内容享有相应权利。</p>
        <p>但用户应确保其使用象寄服务的行为不会侵犯任何第三方权利。</p>
        <h3>平台生成及展示内容</h3>
        <p>
          象寄可能在产品页面、帮助中心、宣传材料或其他场景展示示例图片、模板、字体、图形、商标、人物形象或其他素材。
        </p>
        <p>
          <strong>除象寄明确授权外，您不得将上述内容用于商业用途。</strong>
        </p>
      </section>
      <section>
        <h2>七、收费服务</h2>
        <h3>收费服务</h3>
        <p>象寄部分产品及功能属于收费服务。</p>
        <p>如您使用收费服务，应按照相应页面显示的价格、计费方式及服务规则支付费用。</p>
        <h3>收费标准调整</h3>
        <p>象寄有权根据业务发展、技术成本及市场情况调整收费标准、套餐内容、计费方式及服务额度。</p>
        <p>
          <strong>如调整涉及您已经购买且尚在有效期内的服务权益，象寄将按照适用法律法规及相关购买协议执行。</strong>
        </p>
        <h3>订阅服务</h3>
        <p>如您购买象寄订阅服务，还应遵守《象寄订阅服务购买协议》。</p>
        <p>订阅服务的价格、周期、权益、退款、自动续费等事项，以订阅服务购买页面及相关协议为准。</p>
        <h3>免费服务</h3>
        <p>象寄可能提供部分免费服务、试用额度或体验功能。</p>
        <p>
          <strong>象寄有权根据产品运营情况调整、暂停或终止免费服务。</strong>
        </p>
      </section>
      <section>
        <h2>八、服务变更、中断与终止</h2>
        <h3>服务更新</h3>
        <p>为了改善用户体验、完善产品功能及保证服务安全，象寄可能对产品进行更新、升级、优化、调整或迁移。</p>
        <h3>服务中断</h3>
        <p>因以下原因造成服务暂时中断或无法正常使用的，不视为象寄违约：</p>
        <ul>
          <li>系统维护或升级；</li>
          <li>网络故障；</li>
          <li>电信运营商故障；</li>
          <li>云服务故障；</li>
          <li>第三方AI模型或技术服务故障；</li>
          <li>黑客攻击或网络安全事件；</li>
          <li>不可抗力；</li>
          <li>其他非象寄可合理控制的原因。</li>
        </ul>
        <h3>服务终止</h3>
        <p>如发生以下情形之一，象寄有权暂停或终止向您提供部分或全部服务：</p>
        <ol>
          <li>您违反法律法规；</li>
          <li>您违反本条款或其他象寄服务规则；</li>
          <li>您提供虚假、错误或无法验证的信息；</li>
          <li>相关主管部门要求；</li>
          <li>出于账号、系统或交易安全考虑；</li>
          <li>服务本身因业务、技术或其他原因需要终止；</li>
          <li>其他象寄认为有必要终止服务的合理情形。</li>
        </ol>
        <h3>数据处理</h3>
        <p>服务终止后，象寄可能根据法律法规、隐私政策及相关服务规则删除或匿名化处理您的数据。</p>
        <p>
          <strong>您应当在服务终止前自行备份需要长期保存的用户数据。</strong>
        </p>
      </section>
      <section>
        <h2>九、免责声明与责任限制</h2>
        <h3>不可抗力</h3>
        <p>因不可抗力导致服务无法正常提供的，象寄在法律允许范围内不承担违约责任。</p>
        <p>不可抗力包括但不限于：</p>
        <ul>
          <li>地震；</li>
          <li>台风；</li>
          <li>洪水；</li>
          <li>火灾；</li>
          <li>战争；</li>
          <li>政府行为；</li>
          <li>重大公共卫生事件；</li>
          <li>网络攻击；</li>
          <li>大规模网络故障；</li>
          <li>其他无法合理预见、无法避免且无法克服的事件。</li>
        </ul>
        <h3>第三方服务</h3>
        <p>象寄部分服务依赖第三方网络、支付、云计算、AI模型、翻译引擎及其他服务。</p>
        <p>
          <strong>
            因第三方服务故障、调整、限制或终止造成的服务异常，象寄将在合理范围内尽力协助解决，但不对超出象寄合理控制范围的损失承担责任。
          </strong>
        </p>
        <h3>用户行为风险</h3>
        <p>您理解并同意，使用互联网及AI服务存在一定风险。</p>
        <p>对于因其他用户、第三方或互联网环境产生的信息、内容、行为及风险，象寄不承担法律规定之外的责任。</p>
        <h3>AI服务风险</h3>
        <p>
          <strong>象寄不保证AI生成内容绝对准确、完整、真实、可靠或适用于特定商业目的。</strong>
        </p>
        <p>用户应根据实际使用场景进行独立判断和审核。</p>
        <h3>间接损失</h3>
        <p>
          在法律允许的最大范围内，对于因使用或无法使用象寄服务产生的间接损失、利润损失、商誉损失、业务中断损失或其他特殊损失，象寄不承担责任。
        </p>
        <p>
          <strong>如法律要求象寄承担责任，象寄承担的责任范围以法律规定为限。</strong>
        </p>
      </section>
      <section>
        <h2>十、违规处理及法律责任</h2>
        <h3>违规处理</h3>
        <p>
          如象寄发现或收到举报、投诉，认为您存在违反法律法规、本条款或其他服务规则的行为，象寄有权根据实际情况采取：
        </p>
        <ul>
          <li>警告；</li>
          <li>删除或屏蔽相关内容；</li>
          <li>限制相关功能；</li>
          <li>限制账号访问；</li>
          <li>暂停服务；</li>
          <li>冻结账号；</li>
          <li>终止账号；</li>
          <li>其他合理措施。</li>
        </ul>
        <h3>账号终止</h3>
        <p>
          <strong>如您的行为严重违反法律法规、本条款或其他平台规则，象寄有权暂停或永久终止您的账号及相关服务。</strong>
        </p>
        <p>如因违规导致服务终止，您可能无法继续使用账号中的相关服务权益。</p>
        <h3>用户赔偿责任</h3>
        <p>
          <strong>
            如因您的违法违规行为、侵权行为或违反本条款的行为导致象寄或其关联公司、合作方遭受任何第三方索赔、行政处罚、诉讼、仲裁或其他损失，您应依法承担相应责任，并赔偿因此给象寄造成的合理损失。
          </strong>
        </p>
      </section>
      <section>
        <h2>十一、隐私与个人信息保护</h2>
        <p>象寄重视您的个人信息和隐私保护。</p>
        <p>关于我们如何收集、使用、存储、保护及处理您的个人信息，请参阅象寄发布的《隐私政策》。</p>
        <p>
          <strong>您在注册、登录或使用象寄服务前，应仔细阅读并理解相关隐私政策。</strong>
        </p>
        <p>
          如特定服务涉及跨境数据传输、第三方AI模型或其他特殊数据处理场景，象寄将按照适用法律法规及相关隐私政策进行处理。
        </p>
      </section>
      <section>
        <h2>十二、第三方服务及链接</h2>
        <p>象寄服务可能包含或连接至由第三方提供的网站、软件、API、支付服务、AI模型或其他服务。</p>
        <p>
          <strong>
            第三方服务由相应第三方独立提供，象寄不对第三方服务的准确性、可靠性、合法性或持续可用性作出超出法律规定范围的保证。
          </strong>
        </p>
        <p>如您使用第三方服务，应遵守该第三方的相关服务条款及隐私政策。</p>
        <p>因您使用第三方服务而产生的纠纷，原则上由您与相关第三方自行解决。</p>
      </section>
      <section>
        <h2>十三、服务反馈</h2>
        <p>
          如果您向象寄提供意见、建议、产品反馈或其他信息，您同意象寄可以在不侵犯您依法享有的合法权益的前提下，将相关反馈用于产品改进、技术优化及服务运营。
        </p>
        <p>您理解并同意，除双方另有书面约定外，象寄没有义务因采用您的意见或建议而向您支付任何费用。</p>
      </section>
      <section>
        <h2>十四、条款终止</h2>
        <ol>
          <li>本条款自您注册、登录或首次使用象寄服务之日起生效，并持续有效，直至您注销账号或象寄终止向您提供服务。</li>
          <li>
            本条款终止后，其中根据其性质应当继续有效的条款，包括但不限于知识产权、用户责任、免责声明、责任限制及争议解决等条款，仍然有效。
          </li>
        </ol>
      </section>
      <section>
        <h2>十五、法律适用、管辖与其他</h2>
        <ol>
          <li>
            <strong>本条款的订立、生效、履行、解释、修改、终止及争议解决均适用中华人民共和国法律。</strong>
          </li>
          <li>如因本条款或使用象寄服务产生争议，双方应首先友好协商解决。</li>
          <li>
            <strong>协商不成的，任何一方均可向象寄实际运营主体住所地有管辖权的人民法院提起诉讼。</strong>
          </li>
          <li>如本条款中的任何条款被有管辖权的法院认定为无效、违法或不可执行，不影响其他条款的效力。</li>
          <li>本条款的标题仅为方便阅读而设置，不影响条款的解释或法律效力。</li>
        </ol>
      </section>
      <section>
        <h2>十六、联系我们</h2>
        <p>如您对本条款、象寄产品或相关服务有任何疑问、意见或投诉，可以通过以下方式联系我们：</p>
        <ul>
          <li>
            官方网站：
            <a href="https://www.xiangjifanyi.com/" rel="noreferrer" target="_blank">
              https://www.xiangjifanyi.com/
            </a>
          </li>
          <li>
            <strong>在线客服：</strong>象寄产品内在线客服
          </li>
          <li>
            <strong>客服邮箱：</strong>[请填写官方客服邮箱]
          </li>
          <li>
            <strong>运营主体：</strong>[请填写实际运营主体全称]
          </li>
          <li>
            <strong>注册地址：</strong>[请填写注册地址]
          </li>
        </ul>
        <p>我们将在收到您的咨询或反馈后，在合理期限内进行处理。</p>
      </section>
    </>
  );
};

export default ZhContent;
